'use client';
import React, { FC } from 'react';
import { TypeAddToCartCtaFields } from '@/core/generated-types';
import { Button } from '@/components';
import useProductContext from '@/context/ProductContext';
import { ShopifyProduct } from '@/lib/shopify';
import useInventoryStatus from '@/hooks/useInventoryStatus';
import { useProductValidations } from '@/hooks/useProductValidations';

export interface AddToCartCtaProps extends TypeAddToCartCtaFields {
  form?: string;
  testId?: string;
}

const AddToCartCta: FC<AddToCartCtaProps> = ({
  addToCartText,
  form = 'add-to-cart-form',
  testId,
}) => {
  const productContext = useProductContext();
  const { shopifyProduct, product } = productContext;

  const isValidProduct = useProductValidations(product);
  const isDisabledByValidation = !isValidProduct;

  const [ctaText, ctaClasses, isInventoryDisabled] = useInventoryStatus(
    shopifyProduct as ShopifyProduct,
  );

  // Get validation message from product translations if available
  const ctaValidationMsg =
    product?.fields?.translations?.fields?.ctaValidationMsg;

  // Determine the button text - use validation message when disabled by validation
  const buttonText =
    isDisabledByValidation && ctaValidationMsg
      ? ctaValidationMsg
      : ctaText || addToCartText;

  return (
    <Button
      type="submit"
      ctaText={buttonText}
      form={form}
      classes={ctaClasses}
      disabled={isDisabledByValidation || isInventoryDisabled}
      testId={testId || 'add-to-cart-cta'}
    />
  );
};

export default React.memo(AddToCartCta);
